window.jQuery = $;

$(document).ready(function () {

    const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)

    //Open menu mobile
    $('#toggle-menu').on("click", function() {
        $(this).toggleClass('active');
        $('#menu').slideToggle();
        if ($(this).hasClass('active')) {
            $('body').css({ overflow: 'hidden' });
        }
        else {
            $('body').removeAttr("style");
        }
    });

    //Button filter
    $('#button-filter').on("click", function() {
        $(this).toggleClass('active');
        $('#card-filter').slideToggle();
    });

    //Open accordion
    $('.accordion').each(function() {
        let $this = $(this);

        $this.find('.accordion-title').on('click', () => {
            $this.find('.accordion-body').slideToggle(300, function() {  
                if (vw <= 992) {
                    if ($(this).is(':visible')) {
                        $(this).css('display','flex'); 
                        $(this).css('flex-direction','column'); 
                    }
                }
            })
            $this.toggleClass('active');
        });
    });

    //Open models list
    $('#toggle-models').on('click', e => {
        e.stopPropagation();
        $('.model-list').slideToggle(300);
        $('#toggle-models').toggleClass('active');
        $('.model-list li').on('click', () => {
            $('.model-list').hide();
            $('#toggle-models').removeClass('active');
        });
    })

    $(document).on('click', () => {
        $('.model-list').hide();
        $('#toggle-models').removeClass('active');
    });

    //Open schedule list
    if (vw <= 992) {
        $('#toggle-schedule').on('click', () => {
            $('#toggle-schedule-container').slideToggle(300);
            $('#toggle-schedule').toggleClass('active');
        })
    }

    //See schedules
    $('#see-schedule').on('click', e => {
        document.querySelector('.schedule')?.scrollIntoView({
            behavior: 'smooth'
        });
    })

    $('.collection-products .main-container').on('click', 'button.load-more-products', e => {
        const $this = $(e.currentTarget);
        const $parent = $this.closest('.collection-products-footer');
        const $container = $($('.collection-products .main-container').get(0));
        const url = $this.data('href');

        $parent.remove();

        $.get(url, products => {
            $container.append(products);
        })
        
        
    });

});